<!-- 会员中心页面，显示会员的信息，包括用户名，过期时间等；-->

<template>
  <div class="vip">
    <div class="vip-top">
      <img src="../assets/bg.svg" alt>
      <div class="vip-info-top">
        <div class="back-btn" @click="goBack">返回</div>我的VIP会员
      </div>
      <div class="vip-info-box">
        <img src="../assets/VIPbg.svg" alt v-if="isVip">
        <img src="../assets/timeoutVIPbg.svg" alt v-if="!isVip">
        <div class="vip-outtime" v-if="isVip">{{time}}到期</div>
        <div class="vip-info-title">{{isVip?'尊贵的会员，':''}}欢迎回来!</div>
        <!--<div class="vip-info-nickname">{{nickname}}<img class="vip-tag" src="../assets/VIP.svg" alt=""><img class="open-tag" src="../assets/open.svg" alt=""></div>-->
        <div class="vip-info-nickname">
          {{nickname||userid}}
          <span class="vip-tag" v-if="isVip"></span>
          <span class="open-tag" v-if="!isVip" @click="renewVip"></span>
        </div>
        <div class="vip-info-edit-renew" v-if="autoRenew">
          你已是自动续费会员
          <span @click="showRenewEditFun">[修改自动续费]</span>
        </div>
      </div>
    </div>
    <div class="vip-content">
      <!--会员专属特权-->
      <Privileges :lines="2"/>
    </div>
    <!--会员服务协议-->
    <div class="vip-agreement">
      <span @click="goAgreement">会员服务协议</span>
      <div class="line-left"></div>
      <div class="line-right"></div>
    </div>
    <!--续费按钮-->
    <div class="open-vip-btn" @click="renewVip">会员续费</div>
    <!--开通成功/失败的弹窗-->
    <div class="open-alert-box" v-show="showFailAlert">
      <img src="../assets/success.svg" alt>
      <div class="alert-text">欢迎您，尊敬的会员</div>
    </div>
    <!--修改连续续费-->
    <RenewEdit
      :show="showRenewEdit"
      @hideRenewEdit="hideRenewEditFun"
      @cancelAutoRenew="cancelAutoRenewFun"
    />
    <!--请求失败的弹窗-->
    <Alert ref="alertTem"/>
  </div>
</template>

<script>
import Privileges from "../components/Privileges.vue";
import RenewEdit from "../components/RenewEdit.vue";
import Alert from "../components/Alert.vue";
import LocalStorage from "../utils/localstorage";
import service from "../utils/http";
import { formatDate, isIOS } from "../utils/utils";

export default {
  name: "Vip",
  components: {
    Privileges,
    RenewEdit,
    Alert
  },
  data() {
    return {
      isVip: false,
      time: "2018-10-23",
      nickname: "",
      userid: "",
      autoRenew: false,
      showRenewEdit: false,
      showFailAlert: false,
      timer: null,
      requestNum: 0
    };
  },
  methods: {
    goAgreement: function() {
      this.$router.push({ name: "agreement" });
    },
    renewVip: function() {
      this.$router.push({ name: "home", query: { renew: true } });
    },
    showRenewEditFun: function() {
      this.showRenewEdit = true;
    },
    hideRenewEditFun: function() {
      this.showRenewEdit = false;
    },
    cancelAutoRenewFun: function(value) {
      this.showRenewEdit - false;
      console.log(value);
    },
    showSuccessAlertFun: function() {
      let self = this;
      if (self.timer) {
        clearTimeout(self.timer);
      }
      self.showFailAlert = true;
      self.timer = setTimeout(function() {
        self.showFailAlert = false;
      }, 2000);
    },
    getVipInfo: function() {
      //展示loading
      this.requestNum++;
      this.$refs.alertTem.showLoadingFun();
      let self = this;
      let appkey = LocalStorage.getStr("appkey");
      service({
        method: "post",
        url: "voice_package/getvipinfo",
        data: {
          appkey: appkey,
          goods_type: 2
        }
      })
        .then(function(response) {
          console.log(response);
          //查询是否关闭loading
          self.requestNum--;
          if (self.requestNum <= 0) {
            self.requestNum = 0;
            self.$refs.alertTem.hideLoadingFun();
          }
          if (response.data.code == 0) {
            LocalStorage.setStr("duration_time", response.data.duration_time);
            LocalStorage.setStr("effective_time", response.data.effective_time);
          }
          self.setInfo();
        })
        .catch(function(error) {
          console.log(error);
          self.requestNum = 0;
          self.$refs.alertTem.hideLoadingFun();
          self.$refs.alertTem.showAlertFun();
        });
    },
    setInfo: function() {
      let startTime = LocalStorage.getStr("effective_time") * 1000;
      let duringTime = LocalStorage.getStr("duration_time") * 1000;
      let endTime = startTime + duringTime;
      let endDate = new Date(endTime);
      if (endTime) {
        this.time = formatDate(endDate);
      }
      let now = new Date();
      if (now.getTime() < endTime) {
        this.isVip = true;
      }
    },
    goBack: function() {
      if (isIOS()) {
        //传递给IOS的数据,仅仅IOS有效
        let json = { goback: 1, buyed: localStorage.getItem("buyed") || 0 };
        let jsonStr = JSON.stringify(json);
        //UIWebView使用
        getMessage(jsonStr);
        //WKWebView使用
        //使用下方方法,会报错,为使界面执行逻辑通畅,因此使用try-catch
        try {
          window.webkit.messageHandlers.getMessage.postMessage(jsonStr);
        } catch (error) {
          console.log(error);
        }
      } else {
        let json = { buyed: localStorage.getItem("buyed") || 0 };
        let jsonStr = JSON.stringify(json);
        buyView.close(jsonStr);
        //this.$router.go(-1);
      }
    }
  },
  created() {
    this.nickname = LocalStorage.getStr("nickname");
    this.userid = LocalStorage.getStr("userid");
  },
  mounted: function() {
    console.log("mounted");
    let showAlert = LocalStorage.getStr("showSuccessAlert");
    if (showAlert == "true") {
      LocalStorage.setStr("showSuccessAlert", "false");
      this.getVipInfo();
      this.showSuccessAlertFun();
    } else {
      this.setInfo();
    }
  },
  destroyed: function() {
    let self = this;
    if (self.timer) {
      clearTimeout(self.timer);
    }
  }
};
</script>

<style scoped lang="scss">
.vip {
  overflow-y: auto;
  .vip-top {
    width: 100%;
    height: 3.22rem;
    img {
      height: 1.54rem;
      width: 100%;
      border: none;
      line-height: 0;
    }
    .vip-info-top {
      height: 0.7rem;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 0.22rem;
      line-height: 0.7rem;
      position: absolute;
      left: 0;
      top: 0;
      background: #232220;
      .back-btn {
        height: 0.23rem;
        line-height: 0.23rem;
        width: 0.6rem;
        padding-left: 0.2rem;
        font-size: 0.2rem;
        position: absolute;
        left: 0.3rem;
        top: 0.23rem;
        text-align: left;
        background-image: url("../assets/back_fff.svg");
        background-repeat: no-repeat;
        background-size: 0.13rem 0.23rem;
        background-position: top left;
      }
    }
    .vip-info-box {
      width: 4.9rem;
      height: 2.62rem;
      position: absolute;
      top: 0.7rem;
      left: 50%;
      margin-left: -2.45rem;
      img {
        height: 100%;
        width: 100%;
        float: left;
      }
      .vip-outtime {
        height: 0.55rem;
        width: 1.54rem;
        background-image: url("../assets/tag.svg");
        background-repeat: no-repeat;
        background-size: cover;
        line-height: 0.36rem;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 0.16rem;
        color: #5f5c57;
      }
      .vip-info-title {
        height: 0.26rem;
        width: 100%;
        line-height: 0.26rem;
        position: absolute;
        top: 0.58rem;
        font-size: 0.18rem;
        color: #5f5c57;
      }
      .vip-info-nickname {
        height: 0.42rem;
        line-height: 0.42rem;
        width: 100%;
        font-size: 0.3rem;
        color: #232220;
        position: absolute;
        top: 1rem;
        .vip-tag {
          height: 0.22rem;
          width: 0.4rem;
          display: inline-block;
          background-image: url("../assets/VIP.svg");
          background-size: cover;
          vertical-align: middle;
          margin-left: 0.07rem;
        }
        .open-tag {
          height: 0.26rem;
          width: 0.46rem;
          display: inline-block;
          background-image: url("../assets/open.svg");
          background-size: cover;
          vertical-align: middle;
          margin-left: 0.07rem;
        }
      }
      .vip-info-edit-renew {
        height: 0.25rem;
        line-height: 0.25rem;
        width: 100%;
        font-size: 0.18rem;
        color: #5f5c57;
        position: absolute;
        top: 1.6rem;
        span {
          color: #232220;
        }
      }
    }
  }
  .vip-content {
    width: 100%;
    padding: 0 0.3rem 1.5rem;
    box-sizing: border-box;
  }
  /*******************会员服务协议********************/
  .vip-agreement {
    height: 0.45rem;
    width: 100%;
    line-height: 0.22rem;
    color: #e5cc96;
    text-align: center;
    font-size: 0.16rem;
    text-decoration: underline;
    position: absolute;
    bottom: 0.88rem;
    .line-left {
      height: 0.02rem;
      transform: scaleY(0.5);
      width: 1.78rem;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1),
        rgba(255, 196, 141, 1)
      );
      position: absolute;
      top: 0.1rem;
      left: 0.3rem;
    }
    .line-right {
      height: 0.02rem;
      transform: scaleY(0.5);
      width: 1.78rem;
      background: linear-gradient(
        90deg,
        rgba(255, 196, 141, 1),
        rgba(255, 255, 255, 1)
      );
      position: absolute;
      top: 0.1rem;
      right: 0.3rem;
    }
  }
  /******************开通会员按钮*******************/
  .open-vip-btn {
    width: 4.8rem;
    height: 0.58rem;
    border-radius: 0.08rem;
    background: linear-gradient(
      -90deg,
      rgba(240, 222, 172, 1),
      rgba(218, 185, 127, 1)
    );
    line-height: 0.58rem;
    font-size: 0.22rem;
    color: #232220;
    box-shadow: 0 0.14rem 0.11rem -0.06rem rgba(221, 184, 122, 0.5);
    position: absolute;
    left: 50%;
    margin-left: -2.4rem;
    bottom: 0.3rem;
  }
  /*****************开通成功失败的弹窗***************************/
  .open-alert-box {
    position: fixed;
    height: 1.95rem;
    width: 2.8rem;
    border-radius: 0.08rem;
    background: rgba(0, 0, 0, 0.8);
    left: 50%;
    margin-left: -1.4rem;
    top: 3.17rem;
    padding-top: 0.45rem;
    box-sizing: border-box;
    img {
      height: 0.7rem;
      width: 0.7rem;
      display: block;
      margin: 0 auto;
    }
    .alert-text {
      height: 0.26rem;
      line-height: 0.26rem;
      font-size: 0.18rem;
      color: #fff;
      margin-top: 0.1rem;
    }
  }
}
</style>
